if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');

        this.addEventListener('product-info:loaded', ({ target }) => {
          target.addPreProcessCallback(this.preprocessHTML.bind(this));
        });
      }

      hide(preventFocus = false) {
        publish(PUB_SUB_EVENTS.modalToggle,  { display: true });
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = '';

        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      show(opener) {
        publish(PUB_SUB_EVENTS.modalToggle,  { display: false });
        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');
        opener.querySelector('.loading__spinner').classList.remove('hidden');

        fetch(opener.getAttribute('data-product-url'))
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            const productElement = responseHTML.querySelector('product-info');

            this.preprocessHTML(productElement);
            HTMLUpdateUtility.setInnerHTML(this.modalContent, productElement.outerHTML);

            // Add custom bullets if they exist for this product
            this.addCustomBullets(opener);

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }
            if (window.ProductModel) window.ProductModel.loadShopifyXR();

            super.show(opener);
            
            // Re-apply campaign selector tags + Birthday Sale card after AJAX inject.
            window.setTimeout(function () {
              if (
                window.CampaignSegmentation &&
                typeof window.CampaignSegmentation.reapplyProductSurfaces === 'function'
              ) {
                window.CampaignSegmentation.reapplyProductSurfaces();
              } else if (window.BirthdaySalePDP && typeof window.BirthdaySalePDP.syncAll === 'function') {
                window.BirthdaySalePDP.syncAll();
              }
            }, 0);
          })
          .finally(() => {
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');
            opener.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      preprocessHTML(productElement) {
        productElement.classList.forEach((classApplied) => {
          if (classApplied.startsWith('color-') || classApplied === 'gradient')
            this.modalContent.classList.add(classApplied);
        });
        this.preventDuplicatedIDs(productElement);
        this.removeDOMElements(productElement);
        this.removeGalleryListSemantic(productElement);
        this.updateImageSizes(productElement);
        this.preventVariantURLSwitching(productElement);
      }

      preventVariantURLSwitching(productElement) {
        productElement.setAttribute('data-update-url', 'false');
      }

      removeDOMElements(productElement) {
        const pickupAvailability = productElement.querySelector('pickup-availability');
        if (pickupAvailability) pickupAvailability.remove();

        const productModal = productElement.querySelector('product-modal');
        if (productModal) productModal.remove();

        const modalDialog = productElement.querySelectorAll('modal-dialog');
        if (modalDialog) modalDialog.forEach((modal) => modal.remove());

        const hiddenFromQuickAddElements = productElement.querySelectorAll('.quick-add-hide');
        if (hiddenFromQuickAddElements) hiddenFromQuickAddElements.forEach((el) => el.remove());
      }

      preventDuplicatedIDs(productElement) {
        const sectionId = productElement.dataset.section;

        const oldId = sectionId;
        const newId = `quickadd-${sectionId}`;
        productElement.innerHTML = productElement.innerHTML.replaceAll(oldId, newId);
        Array.from(productElement.attributes).forEach((attribute) => {
          if (attribute.value.includes(oldId)) {
            productElement.setAttribute(attribute.name, attribute.value.replace(oldId, newId));
          }
        });

        productElement.dataset.originalSection = sectionId;
      }

      removeGalleryListSemantic(productElement) {
        const galleryList = productElement.querySelector('[id^="Slider-Gallery"]');
        if (!galleryList) return;

        galleryList.setAttribute('role', 'presentation');
        galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute('role', 'presentation'));
      }

      updateImageSizes(productElement) {
        const product = productElement.querySelector('.product');
        const desktopColumns = product?.classList.contains('product--columns');
        if (!desktopColumns) return;

        const mediaImages = product.querySelectorAll('.product__media img');
        if (!mediaImages.length) return;

        let mediaImageSizes =
          '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

        if (product.classList.contains('product--medium')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '605px');
        } else if (product.classList.contains('product--small')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '495px');
        }

        mediaImages.forEach((img) => img.setAttribute('sizes', mediaImageSizes));
      }

      addCustomBullets(opener) {
        if (!this.modalContent || !opener) return;

        // Find the bullets script - it should be a sibling of the modal or in the parent container
        let bulletsScript = null;

        // Method 1: Check if modal was moved to body, find script in original location
        // The script is rendered before the quick-add-modal in the snippet
        const modalId = this.id;
        if (modalId) {
          // Find the modal-opener that triggers this modal
          const modalOpener = document.querySelector(`[data-modal="#${modalId}"]`);
          if (modalOpener) {
            // Script should be a previous sibling or in the same parent
            let sibling = modalOpener.previousElementSibling;
            while (sibling) {
              if (sibling.tagName === 'SCRIPT' && sibling.hasAttribute('data-custom-bullets')) {
                bulletsScript = sibling;
                break;
              }
              sibling = sibling.previousElementSibling;
            }
            
            // If not found as sibling, check parent container
            if (!bulletsScript) {
              const container = modalOpener.closest('.you-may-also-like__container-wrapper') ||
                               modalOpener.closest('.you-may-also-like__info')?.closest('.you-may-also-like__container-wrapper') ||
                               modalOpener.parentElement?.closest('.you-may-also-like__container-wrapper');
              if (container) {
                bulletsScript = container.querySelector('script[data-custom-bullets]');
              }
            }
          }
        }

        // Method 2: Fallback - find any bullets script (for cases where structure differs)
        if (!bulletsScript) {
          const allBulletsScripts = document.querySelectorAll('script[data-custom-bullets]');
          bulletsScript = allBulletsScripts[0] || null;
        }

        if (bulletsScript) {
          this.insertBullets(bulletsScript);
        }
      }

      insertBullets(bulletsScript) {
        if (!this.modalContent || !bulletsScript) return;

        const bulletsText = bulletsScript.getAttribute('data-bullets-data');
        if (!bulletsText) return;

        // Parse bullets (separated by |||)
        const bullets = bulletsText.split('|||').filter(b => b.trim() !== '');

        if (bullets.length === 0) return;

        // Find the product__info-wrapper and ic-wrapper
        const productInfoWrapper = this.modalContent.querySelector('.product__info-wrapper');
        if (!productInfoWrapper) return;

        const icWrapper = productInfoWrapper.querySelector('.ic-wrapper');
        if (!icWrapper) return;

        // Check if bullets already exist
        const existingBullets = productInfoWrapper.querySelector('.you-may-also-like__custom-bullets');
        if (existingBullets) {
          existingBullets.remove();
        }

        // Create bullets container
        const bulletsContainer = document.createElement('div');
        bulletsContainer.className = 'you-may-also-like__custom-bullets flex flex-column space-x0-5';

        // Create bullet elements
        bullets.forEach((bulletText) => {
          if (!bulletText || bulletText.trim() === '') return;

          const bulletWrapper = document.createElement('div');
          bulletWrapper.className = 'description-bullet__wrapper flex flex-row items-center';

          const svgIcon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
          svgIcon.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
          svgIcon.setAttribute('width', '24');
          svgIcon.setAttribute('height', '24');
          svgIcon.setAttribute('viewBox', '0 0 24 24');
          svgIcon.setAttribute('fill', 'none');

          const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
          path.setAttribute('d', 'M16.7992 8.40039L9.6397 15.6004L7.19922 13.1461');
          path.setAttribute('stroke', '#000413');
          path.setAttribute('stroke-width', '2');
          path.setAttribute('stroke-linecap', 'round');
          path.setAttribute('stroke-linejoin', 'round');
          svgIcon.appendChild(path);

          const textElement = document.createElement('p');
          textElement.className = 'text-body';
          textElement.innerHTML = bulletText.trim();

          bulletWrapper.appendChild(svgIcon);
          bulletWrapper.appendChild(textElement);
          bulletsContainer.appendChild(bulletWrapper);
        });

        // Insert before ic-wrapper
        icWrapper.parentNode.insertBefore(bulletsContainer, icWrapper);
      }
    }
  );
}
